module.exports = __webpack_public_path__ + "img/howit-second.ca9e7a44.png";